export const SMART_APPOINTMENT_CATEGORY = ['ABA', 'DT', 'MED'];
